import Menu from "./Menu";
import Logo from "./Logo";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useRef,useLayoutEffect } from "react";


// nav component
const Nav = ({ items, headerlogo}) => {
  const newLocation = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [activeLink, setActiveLink] = useState({ initialValue: items[0] });

  //menu opem/close
  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  //sticky header while scrolling
  useEffect(() => {
    const handleScrollPage = () => {
      setIsSticky(window.scrollY > window.innerHeight || window.scrollY > 105);
    };
    window.addEventListener('scroll', handleScrollPage);
    return () => {
      window.removeEventListener('scroll', handleScrollPage);
    };
  }, []);





  useEffect(() => {
    if (!!items && newLocation.pathname === '/' && newLocation.hash === '') {

      window.scrollTo({ top: 0, behavior: 'smooth' });
      setActiveLink(items[0]);
    }else if(newLocation.pathname !== '/'){
      // setActiveLink(null);
      setActiveLink(items.find((item) => item.slug.includes(newLocation.pathname.split('/')[1])));
    }
    else if(!!items && newLocation.pathname === '/' && newLocation.hash){
      setTimeout(() => {
       const targetId =newLocation.hash.split('#')[1];
      const targetElement = document.getElementById(targetId);
           if (targetElement) {
            setActiveLink(items.find((item) => item.ref_link_href && item.ref_link_href.includes(newLocation.hash)));
             window.scrollTo({ top: targetElement.offsetTop - 100, behavior: 'smooth' });
           }
          }, 1000);
    }
    
  }, [items, newLocation.pathname]);



  const location = useRef(null);
  useLayoutEffect(() => {
    const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const docHeight = document.body.offsetHeight;
        items.forEach((item) => {
          if (item.ref_link_href && item.ref_link_href.includes('#')) {
            const sectionId = item.ref_link_href.split('#')[1];
            const targetElement = document.getElementById(sectionId);
            
            if (targetElement !== null) {
              const sectionTop = targetElement.offsetTop;
              const sectionBottom = targetElement.offsetTop + targetElement.offsetHeight;
          
              if (scrollTop + windowHeight >= sectionTop && scrollTop + windowHeight <= sectionBottom) {
                setActiveLink(item);
              }
            }
          }
        });
   
        setTimeout(() => {
          const hash = window.location.hash;
        if (hash) {
          const targetElement = document.getElementById(hash.split('#')[1]);
          if (targetElement) {
            window.scrollTo({ top: targetElement.offsetTop - 100, behavior: 'smooth' });
          }
        }
          }, 1500);
  }, [items]);

  const handleScrollToLink = (event) => {
    
   // event.preventDefault();
    // if (event.target.host !== window.location.host || window.location.pathname !== event.target.pathname)  {
    //   window.location.href = event.target.href;
    //   return;
    // }
    const targetId = event.target.href.split('#')[1];
    const targetElement = document.getElementById(targetId);
    //window.location.href = event.target.href
    if (targetElement) {
      
      window.scrollTo({ top: targetElement.offsetTop - 100, behavior: 'smooth' });
    }
    

    if (window.innerWidth < 991) {
      handleToggle();
    }

    const currentActiveLink = event.target.closest('li');
    currentActiveLink.classList.add('active');
  
    // Remove active class from previous active link
    const previousActiveLink = document.querySelector('.nav-item.active');
    previousActiveLink && previousActiveLink.classList.remove('active');

   
  };

  //page scroll
  useEffect(() => {
    const handleScroll = () => {
      items.forEach((item) => {
        if (item.ref_link_href && item.ref_link_href.includes('#')) {
          const sectionId = item.ref_link_href.split('#')[1];
          const targetElement = document.getElementById(sectionId);
          if (targetElement !== null) {
            
            if (window.scrollY >= targetElement.offsetTop - 102) {
              setActiveLink(item);
            }
            
          }
        }
      });
      
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [items]);

  useLayoutEffect(() => {
    const currentHash = window.location.hash;
    if (currentHash && items.some((item) =>  item.ref_link_href && item.ref_link_href.includes(currentHash))) {
      const targetId = currentHash.split('#')[1];
      const targetElement = document.getElementById(targetId);
      if (targetElement !== null) {
        setActiveLink(items.find((item) => item.ref_link_href && item.ref_link_href.includes(currentHash)));
        window.scrollTo({ top: targetElement.offsetTop - 100, behavior: 'smooth' });
      }
    } else if (window.location.pathname === '/') {
      const homeItem = items.find((item) => item.ref_link_href === '/');
      if (homeItem) {
        setActiveLink(homeItem);
      }
    }
  }, [items, window.location.hash]);


    return(
    
      <nav className={`navbar navbar-sticky navbar-expand-lg ${isSticky ? 'navbar-fixed' : ''}`} id="primary-menu">
        <div className="container">
          <Logo logo={headerlogo}></Logo>
          <button
            className={`navbar-toggler  ${isToggled ? "" : "collapsed "}`}
            type="button"
            onClick={handleToggle}
            data-target="#navbarContent"
            aria-expanded={isToggled ? "true" : "false"}
          >
            <span className={`navbar-toggler-icon ${isToggled ? 'active' : ''}`}></span>
          </button>
          <div className={`collapse navbar-collapse ${isToggled ? 'show' : ''}`} id="navbarContent">
            {/* <Menu items={items}></Menu> */}

            <ul className="navbar-nav ml-auto " >
        {Array.isArray(items) && items.map((item) => (
          <li key={item._key} className={`nav-item main-menu ${activeLink === item ? 'active' : ''}`}>

            
        {/* {item._type === 'linkInternal' ?
          (<Link  className="nav-link" to={`/${item.slug}`}  onClick={(event) => handleScrollToLink(event)} >{item.title}</Link>)
          :( <Link  className="nav-link" to={`${item.slug}`}  onClick={(event) => handleScrollToLink(event)} target="_blank">{item.title}</Link>)
          } */}
            <Link
              className="nav-link"
              to={{
                pathname: item.ref_link_href?.includes("") ? "/" : item.slug,
                hash: item.ref_link_href?.includes("#") ? item.ref_link_href : ""
              }}
              target={item._type !== 'linkInternal' ? '_blank' : null}
              onClick={(event) => handleScrollToLink(event)}
            >{item.title}</Link>
            {item.submenu && (
              <ul className="sub-menu navbar-nav ml-auto">
                {Array.isArray(item.submenu) && item.submenu.map((submenuItem) => (
                  <li key={submenuItem.id} className="nav-item">
                    <a className="nav-link">{submenuItem.label}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>


          </div>
        </div>
      </nav>
      
    );
}
  
export default Nav;